import React, { Component } from 'react';
import { Switch } from 'react-router-dom'
import Grid from './grid'
import Form from './form'
import PrivateRoute from '../../containers/PrivateRoute'

class Empresa extends Component {
	render() {
		return (
			<div className="hdv-render-div">
				<div className="col-md-12 hdv-bloco-top-space hdv-zera-padding-left-right-boostrap">

                    <Switch>
                        <PrivateRoute exact path='/empresa' component={Grid}/>
                        <PrivateRoute path='/empresa/novo' component={Form}/>
                        <PrivateRoute path='/empresa/:id/editar' component={Form}/>
                    </Switch>

				</div>
			</div>
		);
	}
}

export default Empresa;
